import { z } from 'zod';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    startFree: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    onboarding: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    personalAccountSuppliers: z.string().min(1),
    accountHome: z.string().min(1),
    accountSettings: z.string().min(1),
    accountBilling: z.string().min(1),
    accountMembers: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    accountSuppliers: z.string().min(1),
    accountProducts: z.string().min(1),
    accountOrders: z.string().min(1),
    accountCosts: z.string().min(1),
    accountSamples: z.string().min(1),
    accountDocuments: z.string().min(1),
    accountInventory: z.string().min(1),
    accountLocations: z.string().min(1),
    personalAccountProducts: z.string().min(1),
    personalAccountOrders: z.string().min(1),
    accountSettingsBrands: z.string().min(1),
    accountSettingsNaming: z.string().min(1),
    joinTeam: z.string().min(1),
    /**
     * `/dashboard` is no longer a route tree — it is a catch-all that resolves
     * the user's first workspace and forwards to `/home/[account]/*`. These
     * entries remain as slug-less fallbacks for the few places that render
     * before an account slug is known.
     */
    dashboard: z.string().min(1),
    dashboardProducts: z.string().min(1),
    dashboardSamples: z.string().min(1),
  }),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    startFree: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
  },
  app: {
    home: '/home',
    onboarding: '/onboarding',
    personalAccountSettings: '/home/settings',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    personalAccountSuppliers: '/home/suppliers',
    accountHome: '/home/[account]',
    accountSettings: `/home/[account]/settings`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountBillingReturn: `/home/[account]/billing/return`,
    accountSuppliers: `/home/[account]/suppliers`,
    accountProducts: `/home/[account]/products`,
    accountOrders: `/home/[account]/orders`,
    accountCosts: `/home/[account]/costs`,
    accountSamples: `/home/[account]/samples`,
    accountDocuments: `/home/[account]/documents`,
    accountInventory: `/home/[account]/inventory`,
    accountLocations: `/home/[account]/locations`,
    personalAccountProducts: '/home/products',
    personalAccountOrders: '/home/orders',
    accountSettingsBrands: `/home/[account]/settings/brands`,
    accountSettingsNaming: `/home/[account]/settings/naming`,
    joinTeam: '/join',
    dashboard: '/dashboard',
    dashboardProducts: '/dashboard/products',
    dashboardSamples: '/dashboard/samples',
  },
} satisfies z.infer<typeof PathsSchema>);

export default pathsConfig;
